import { fetchConversionTracking } from '@bingads-webui-campaign/overview-cards-common';

export function fetchConversionTrackingData({
  entitySet,
  // we are not using this info in current conversion tracking card, maybe we shoud add it back?
  // metric,
  // selectedMenuItem,
  getCardsConfig,
  filter,
  p$DateRange,
  jsdata,
  dateUtil,
  permissions,
  campaignType,
}) {
  return p$DateRange.then(dateRange => fetchConversionTracking({
    entitySet,
    dateRange,
    // we are not using this info in current conversion tracking card, maybe we shoud add it back?
    // metric,
    // selectedMenuItem,
    jsdata,
    dateUtil,
    getCardsConfig,
    filter,
    permissions,
    campaignType,
  }));
}
